/* eslint-disable no-plusplus */
/* eslint-disable radix */
/**
 * @typedef {import('../types/extraAdds').ExtraAdds} ExtraAdds
 * @typedef {import('../types/extraAdds').SimpleExtraAddAtributtes} SimpleExtraAddAtributtes
 */

/**
 *
 * @param {string} cpf
 * @return {boolean}
 */
const isCPFValid = cpf => {
  // Remove caracteres não numéricos
  cpf = cpf.replace(/\D/g, '');

  // Verifica se o CPF tem 11 dígitos
  if (cpf.length !== 11) {
    return false;
  }

  // Verifica se todos os dígitos são iguais
  const allDigitsAreEqual = /^(.)\1*$/.test(cpf);
  if (allDigitsAreEqual) {
    return false;
  }

  // Calcula o primeiro dígito verificador
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let remainder = 11 - (sum % 11);
  let firstDigit = remainder === 10 || remainder === 11 ? 0 : remainder;

  // Verifica se o primeiro dígito verificador está correto
  if (parseInt(cpf.charAt(9)) !== firstDigit) {
    return false;
  }

  // Calcula o segundo dígito verificador
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cpf.charAt(i)) * (11 - i);
  }
  remainder = 11 - (sum % 11);
  let secondDigit = remainder === 10 || remainder === 11 ? 0 : remainder;

  // Verifica se o segundo dígito verificador está correto
  if (parseInt(cpf.charAt(10)) !== secondDigit) {
    return false;
  }

  // Se chegou até aqui, o CPF é válido
  return true;
};

/**
 * @type {SimpleExtraAddAtributtes}
 */
const cpfBasic = {
  required: false,
  value: '',
};

export const cpfUtils = {
  isCPFValid,
  cpfBasic,
};
